/* eslint-disable */
import layout from '../layout/index.vue'
import Login from '../views/login/index.vue' //登录
import editPassword from '../views/personalCentre/masterMessage/masterMessage.vue' //修改密码

// 系统首页
import home from '../views/home/index';

// 系统管理
import userInformation1 from '../views/systemManagement/userInformationOne/userInformationOne.vue'; //用户信息
import userAccountOpening from '../views/systemManagement/userAccountOpening/userAccountOpening.vue'; //用户开户
import IdentityUpgrade from '../views/systemManagement/IdentityUpgrade/IdentityUpgrade.vue'; //身份升级
import roleInformation from '../views/systemManagement/roleInformation/roleInformation.vue'; //角色信息
import institutionalInformation from '../views/systemManagement/institutionalInformation/institutionalInformation.vue'; //机构信息
import rotationChartManagement from '../views/systemManagement/rotationChartManagement/rotationChartManagement.vue'; //轮播图管理
import announcementManagement from '../views/systemManagement/announcementManagement/announcementManagement.vue'; //公告管理
import systemArticleManagement from '../views/systemManagement/systemArticleManagement/systemArticleManagement.vue'; //系统文章管理
import developAlliedPosterManagement
    from '../views/systemManagement/developAlliedPosterManagement/developAlliedPosterManagement.vue'; //发展盟友海报管理
import roleList from '../views/systemManagement/roleInformation/rolelist.vue'; //角色管理
import userList from '../views/systemManagement/roleInformation/userlist.vue'; //管理员管理

// 用户管理
import userInformation2 from '../views/userManagement/userInformation/userInformation.vue'; //用户信息
import userBalance from '../views/userManagement/userBalance/userBalance.vue'; //用户余额
import userDormant from '../views/userManagement/userDormant/userDormant.vue'; //休眠用户
import expRewards from '../views/rewards/expRewards/expRewards.vue'; //拓展奖励
import bonusRewards from '../views/rewards/bonusRewards/bonusRewards.vue'; //私董会分红
import productAuth from '../views/userManagement/product/productAuth.vue'; //产品授权
import identMember from '../views/userManagement/identMember/identMember.vue'; //常驻会员


// 数据管理
import windControlSystem from '../views/dataManagement/windControlSystem/windControlSystem.vue'; //风控系统
import dataRanking from '../views/dataManagement/dataRanking/dataRanking.vue'; //数据排行
import dataSummary from '../views/dataManagement/dataSummary/dataSummary.vue'; //数据汇总

// 机具管理
import machineInformation from '../views/machineManagement/machineInformation/machineInformation.vue'; //机具信息
import machineInventory from '../views/machineManagement/machineInventory/machineInventory.vue'; //机具库存
import transferRecords from '../views/machineManagement/transferRecords/transferRecords.vue'; //调拨记录
import forceCallBack from '../views/machineManagement/forceCallBack/forceCallBack.vue'; //强制回拨
import addIntegral from '../views/machineManagement/addIntegral/addIntegral.vue'; //达标撤机补积分

//奖励管理
import activateRewards from '../views/rewards/activateRewards/activateRewards.vue'; //激活奖励
import recommendRewards from '../views/rewards/recommendRewards/recommendRewards.vue'; //推荐奖励
import reachRewards from '../views/rewards/reachRewards/reachRewards.vue'; //达标奖励


// 商户管理
import businessInformation from '../views/businessManagement/businessInformation/businessInformation.vue'; //商户信息
import dormantBusiness from '../views/businessManagement/dormantBusiness/dormantBusiness.vue'; //休眠商户
import storeInfo from "@/views/businessManagement/storeInfo/storeInfo.vue";//门店信息

// 订单管理
import orderInquiry from '../views/orderManagement/orderInquiry/orderInquiry.vue'; //商品订单查询
import pointsExchangeOrder from '../views/orderManagement/pointsExchangeOrder/pointsExchangeOrder.vue'; //积分兑换订单
import orderCollection from '../views/orderManagement/orderCollection/orderCollection.vue'; //订单收款统计
import organisationsCollection from '../views/orderManagement/organisationsCollection/organisationsCollection.vue'; //机构收款统计

// 交易管理
import tradingInformation from '../views/transactionManagement/tradingInformation/tradingInformation.vue'; //交易信息
// import tradeCompliance from '../views/transactionManagement/tradeCompliance/tradeCompliance.vue'; //交易达标

// 分润管理
import profitInformation from '../views/profitsManagement/profitInformation/profitInformation.vue'; //分润信息
import institutionalIncome from '../views/profitsManagement/institutionalIncome/institutionalIncome.vue'; //机构收益
import withdrawalInformation from '../views/profitsManagement/withdrawalInformation/withdrawalInformation.vue'; //提现信息
import agency from '../views/profitsManagement/agency/agency.vue'; //机构代付
import refundTreatment from '../views/profitsManagement/refundTreatment/refundTreatment.vue'; //退汇处理
import payAccount from '../views/profitsManagement/payAccount/payAccount.vue'; //代付账户



// 运维中心
import message from '../views/operationsCenter/message/message.vue'; //消息信息
import feedback from '../views/operationsCenter/feedback/feedback.vue'; //意见反馈

// 配置中心
import goldConfiguration from '../views/configurationCenter/goldConfiguration/goldConfiguration.vue'; //金牌配置
import headquartersConfiguration
    from '../views/configurationCenter/headquartersConfiguration/headquartersConfiguration.vue'; //金牌总部配置
import directMarketingConfiguration
    from '../views/configurationCenter/directMarketingConfiguration/directMarketingConfiguration.vue'; //直营配置
import operatingCenterProfits from '../views/configurationCenter/operatingCenterProfits/operatingCenterProfits.vue'; //运营中心分润

// 个人中心
// import masterMessage from '../views/personalCentre/masterMessage/masterMessage.vue'; //我的主信息
import myQrCode from '../views/personalCentre/myQrCode/myQrCode.vue'; //我的二维码
// import subOperationsCentre from '../views/personalCentre/subOperationsCentre/subOperationsCentre.vue'; //推广子运营中心

// 商品管理
import commodityManagement from '../views/commodityManagement/commodityManagement.vue'; //商品管理
import productDetails from '../views/commodityManagement/productDetails.vue'; //商品管理详情

// 系统参数设置
import systemParameterSetting from '../views/systemParameterSetting/index'; //系统参数设置

// 商学院
import articleManagement from '../views/businessSchool/articleManagement/articleManagement.vue'; //文章管理
import articleDetails from '../views/businessSchool/articleManagement/articleDetails.vue'; //资讯详情
import classificationManagement from '../views/businessSchool/classificationManagement/classificationManagement.vue'; //分类管理
import subClassificationManage from '../views/businessSchool/classificationManagement/subClassificationManage.vue'; //子分类管理

//路由文件
const routes = [
    {
        path: '/login',
        component: Login,
        hidden: true
    },{
        path: '',
        name: 'home',
        meta: {
            title: '系统首页'
        },
        children: [
            {
                path: '/home',
                component: home,
                meta: {
                    title: '系统首页'
                },
            },
        ],
        component: layout,
    },
    {
        path: '/dataManagement',
        name: 'dataManagement',
        meta: {
            title: '数据管理'
        },
        component: layout,
        children: [
            {
                path: '/dataSummary',
                name: 'dataSummary',
                meta: {
                    title: '数据汇总'
                },
                component: dataSummary
            }, {
                path: '/dataRanking',
                name: 'dataRanking',
                meta: {
                    title: '数据排行'
                },
                component: dataRanking
            }, {
                path: '/windControlSystem',
                name: 'windControlSystem',
                meta: {
                    title: '风控系统'
                },
                component: windControlSystem
            },{
                path: '/orderCollection',
                name: 'orderCollection',
                meta: {
                    title: '订单收款统计'
                },
                component: orderCollection
            }, {
                path: '/organisationsCollection',
                name: 'organisationsCollection',
                meta: {
                    title: '机构收款统计'
                },
                component: organisationsCollection
            }
        ]
    },{
        path: '/systemManagement',
        name: 'systemManagement',
        meta: {
            title: '系统管理'
        },
        component: layout,
        children: [
            {
                path: '/roleInformation',
                name: 'roleInformation',
                meta: {
                    title: '角色信息'
                },
                component: roleInformation
            },
            {
                path: '/rotationChartManagement',
                name: 'rotationChartManagement',
                meta: {
                    title: '轮播图管理'
                },
                component: rotationChartManagement
            },
            {
                path: '/announcementManagement',
                name: 'announcementManagement',
                meta: {
                    title: '公告管理'
                },
                component: announcementManagement
            },{
                path: '/systemParameterSetting',
                name: 'systemParameterSetting',
                component: systemParameterSetting,
                meta: {
                    title: '系统参数设置'
                },
            },{
                path: '/systemArticleManagement',
                name: 'systemArticleManagement',
                meta: {
                    title: '系统文章管理'
                },
                component: systemArticleManagement
            },{
                path: '/developAlliedPosterManagement',
                name: 'developAlliedPosterManagement',
                meta: {
                    title: '海报管理'
                },
                component: developAlliedPosterManagement
            },  {
                path: '/message',
                name: 'message',
                meta: {
                    title: '消息信息'
                },
                component: message
            }, {
                path: '/feedback',
                name: 'feedback',
                meta: {
                    title: '意见反馈'
                },
                component: feedback
            },
            {
                path: '/roleList',
                name: 'roleList',
                meta: {
                    title: '角色管理'
                },
                component: roleList
            },
            {
                path: '/userList',
                name: 'userList',
                meta: {
                    title: '用户管理'
                },
                component: userList
            }
        ]
    }, {
        path: '/userManagement',
        name: 'userManagement',
        meta: {
            title: '用户管理'
        },
        component: layout,
        children: [
            {
                path: '/userInformationOne',
                name: 'userInformationOne',
                meta: {
                    title: '用户信息'
                },
                component: userInformation1
            },
			{
			    path: '/userAccountOpening',
			    name: 'userAccountOpening',
			    meta: {
			        title: '用户开户'
			    },
			    component: userAccountOpening
			},
			{
			    path: '/IdentityUpgrade',
			    name: 'IdentityUpgrade',
			    meta: {
			        title: '身份升级'
			    },
			    component: IdentityUpgrade
			},
            {
                path: '/userInformation',
                name: 'userInformation',
                meta: {
                    title: '账户管理'
                },
                component: userInformation2
            },{
                path: '/institutionalInformation',
                name: 'institutionalInformation',
                meta: {
                    title: '机构信息'
                },
                component: institutionalInformation
            },
            {
                path: '/userDormant',
                name: 'userDormant',
                meta: {
                    title: '休眠用户'
                },
                component: userDormant
            },{
                path: '/goldConfiguration',
                name: 'goldConfiguration',
                meta: {
                    title: '金牌配置'
                },
                component: goldConfiguration
            },
            {
                path: '/headquartersConfiguration',
                name: 'headquartersConfiguration',
                meta: {
                    title: '金牌总部配置'
                },
                component: headquartersConfiguration
            },{
                path: '/directMarketingConfiguration',
                name: 'directMarketingConfiguration',
                meta: {
                    title: '直营配置'
                },
                component: directMarketingConfiguration
            },
            // {
            //     path: '/subOperationsCentre',
            //     name: 'subOperationsCentre',
            //     meta: {
            //         title: '推广子运营中心'
            //     },
            //     component: subOperationsCentre
            // }
            {
                path: '/productAuth',
                name: 'productAuth',
                meta: {
                    title: '产品授权'
                },
                component: productAuth
            },
            {
                path: '/identMember',
                name: 'identMember',
                meta: {
                    title: '常驻会员'
                },
                component: identMember
            },
            
            
        ]
    },
    {
        path: '/businessManagement',
        name: 'businessManagement',
        meta: {
            title: '商户管理'
        },
        component: layout,
        children: [
            {
                path: '/businessInformation',
                name: 'businessInformation',
                meta: {
                    title: '商户信息'
                },
                component: businessInformation
            },
            {
                path: '/storeInfo',
                name: 'storeInfo',
                meta: {
                    title: '门店信息'
                },
                component: storeInfo
            },
            {
                path: '/dormantBusiness',
                name: 'dormantBusiness',
                meta: {
                    title: '休眠商户'
                },
                component: dormantBusiness
            }
        ]
    }, {
        path: '/machineManagement',
        name: 'machineManagement',
        meta: {
            title: '终端管理'
        },
        component: layout,
        children: [
            {
                path: '/machineInformation',
                name: 'machineInformation',
                meta: {
                    title: '终端信息'
                },
                component: machineInformation
            },
            {
                path: '/machineInventory',
                name: 'machineInventory',
                meta: {
                    title: '终端库存'
                },
                component: machineInventory
            },
            {
                path: '/transferRecords',
                name: 'transferRecords',
                meta: {
                    title: '调拨记录'
                },
                component: transferRecords
            }, {
                path: '/forceCallBack',
                name: 'forceCallBack',
                meta: {
                    title: '强制回拨'
                },
                component: forceCallBack
            },
        ]
    },{
        path: '/transactionManagement',
        name: 'transactionManagement',
        meta: {
            title: '交易管理'
        },
        component: layout,
        children: [
            {
                path: '/tradingInformation',
                name: 'tradingInformation',
                meta: {
                    title: '交易信息'
                },
                component: tradingInformation
            }
        ]
    },{
        path: '/profitsManagement',
        name: 'profitsManagement',
        meta: {
            title: '分润管理'
        },
        component: layout,
        children: [
            {
                path: '/profitInformation',
                name: 'profitInformation',
                meta: {
                    title: '分润信息'
                },
                component: profitInformation
            },
            {
                path: '/institutionalIncome',
                name: 'institutionalIncome',
                meta: {
                    title: '机构收益'
                },
                component: institutionalIncome
            },
            {
                path: '/operatingCenterProfits',
                name: 'operatingCenterProfits',
                meta: {
                    title: '运营中心分润'
                },
                component: operatingCenterProfits
            }
        ]
    },{
        path: '/profitsManagement',
        name: 'profitsManagement',
        meta: {
            title: '奖励管理'
        },
        component: layout,
        children: [
            {
                path: '/addIntegral',
                name: 'addIntegral',
                meta: {
                    title: '达标撤机补积分'
                },
                component: addIntegral
            },
            {
                path: '/activateRewards',
                name: 'activateRewards',
                meta: {
                    title: '激活奖励'
                },
                component: activateRewards
            },
            {
                path: '/recommendRewards',
                name: 'recommendRewards',
                meta: {
                    title: '推荐奖励'
                },
                component: recommendRewards
            },
            {
                path: '/reachRewards',
                name: 'reachRewards',
                meta: {
                    title: '达标奖励'
                },
                component: reachRewards
            },

            // {
            //     path: '/tradeCompliance',
            //     name: 'tradeCompliance',
            //     meta: {
            //         title: '月达标审核'
            //     },
            //     component: tradeCompliance
            // },
        ]
    },{
        path: '/profitsManagement',
        name: 'profitsManagement',
        meta: {
            title: '钱包管理'
        },
        component: layout,
        children: [
            {
                path: '/userBalance',
                name: 'userBalance',
                meta: {
                    title: '用户余额'
                },
                component: userBalance
            },
            {
                path: '/withdrawalInformation',
                name: 'withdrawalInformation',
                meta: {
                    title: '提现审核'
                },
                component: withdrawalInformation
            }, {
                path: '/agency',
                name: 'agency',
                meta: {
                    title: '机构代付'
                },
                component: agency
            },
            {
                path: '/refundTreatment',
                name: 'refundTreatment',
                meta: {
                    title: '退汇处理'
                },
                component: refundTreatment
            },
            {
                path: '/payAccount',
                name: 'payAccount',
                meta: {
                    title: '代付账户'
                },
                component: payAccount
            },
            {
                path: '/expRewards',
                name: 'expRewards',
                meta: {
                    title: '拓展奖励'
                },
                component: expRewards
            },
            {
                path: '/bonusRewards',
                name: 'bonusRewards',
                meta: {
                    title: '私董会分红'
                },
                component: bonusRewards
            }
        
        ]
    },{
        path: '/profitsManagement',
        name: 'profitsManagement',
        meta: {
            title: '商城管理'
        },
        component: layout,
        children: [
            {
                path: '/commodityManagement',
                component: commodityManagement,
                meta: {
                    title: '商品管理'
                },
            },
            {
                path: '/productDetails',
                name: 'productDetails',
                meta: {
                    title: '商品详情'
                },
                component: productDetails
            }, {
                path: '/orderInquiry',
                name: 'orderInquiry',
                meta: {
                    title: '商品订单'
                },
                component: orderInquiry
            }, {
                path: '/pointsExchangeOrder',
                name: 'pointsExchangeOrder',
                meta: {
                    title: '积分订单'
                },
                component: pointsExchangeOrder
            },
        ]
    },{
        path: '/profitsManagement',
        name: 'profitsManagement',
        meta: {
            title: '知识管理'
        },
        component: layout,
        children: [
            {
                path: '/articleManagement',
                name: 'articleManagement',
                meta: {
                    title: '文章管理'
                },
                component: articleManagement
            },
            {
                path: '/classificationManagement',
                name: 'classificationManagement',
                meta: {
                    title: '分类管理'
                },
                component: classificationManagement
            },
            {
                path: '/articleDetails',
                name: 'articleDetails',
                meta: {
                    title: '资讯详情'
                },
                component: articleDetails
            },
            {
                path: '/subClassificationManage',
                name: 'subClassificationManage',
                meta: {
                    title: '子分类管理'
                },
                component: subClassificationManage
            },
        ]
    },{
        path: '',
        name: 'editPassword',
        meta: {
            title: '修改密码'
        },
        component: layout,
        children: [
            {
                path: '/editPassword',
                component: editPassword,
                meta: {
                    title: '修改密码'
                },
            }
        ]
    },{
        path: '',
        name: 'myQrCode',
        meta: {
            title: '我的二维码'
        },
        component: layout,
        children: [
            {
                path: '/myQrCode',
                component: myQrCode,
                meta: {
                    title: '我的二维码'
                },
            }
        ]
    },
]


export default routes;
